export default "__VITE_PUBLIC_ASSET__6ba05d53__"